// ============================================================
// systems/cursor.js — Custom cursor tracking & animation
// ============================================================
import { state } from '../state.js';
import { dom } from '../dom.js';

/**
 * Initialise all cursor-related listeners.
 * Call once after DOM is ready.
 */
export function initCursor() {
  document.addEventListener('mousemove', (e) => {
    state.mouseX = e.clientX;
    state.mouseY = e.clientY;
    dom.cursor.style.left = e.clientX + 'px';
    dom.cursor.style.top = e.clientY + 'px';
  });

  document.addEventListener('mousedown', () => {
    dom.cursor.classList.add('clicking');
    dom.cursor.src = '/images/MouseClick.png';
  });
  document.addEventListener('mouseup', () => {
    dom.cursor.classList.remove('clicking');
    dom.cursor.src = '/images/Mouse.png';
  });

  // Touch tracking — updates mouseX/Y so hazard collision works on mobile
  document.addEventListener('touchmove', (e) => {
    const t = e.touches[0];
    if (t) { state.mouseX = t.clientX; state.mouseY = t.clientY; }
  }, { passive: true });

  document.addEventListener('touchstart', (e) => {
    const t = e.touches[0];
    if (t) { state.mouseX = t.clientX; state.mouseY = t.clientY; }
  }, { passive: true });
}
